<template>
  <l-layout :layout="['xs12','md10']">
    <v-card>
      <v-card-title style="height: 64px">
        <span class="title pl-2">违章事件上报</span>
        <span class="pl-4 grey--text">{{VIOLATION_ROLE_TEXT[role]}}</span>
      </v-card-title>
      <v-card-text>
        <v-container class="pt-0" fluid grid-list-md>
          <v-form ref="event" v-model="valid">
            <v-layout class="mb-4" wrap>
              <v-flex sm6 xs12>
                <l-plate-picker
                  required="必须填写车辆号牌"
                  v-model="event.plate"
                  :hint="hasSearched && !hasVehicleInfo ? '未获取到该车辆信息' : ''"
                ></l-plate-picker>
              </v-flex>
              <v-flex sm6 xs12>
                <select-violation-area
                  v-model="event.results[role].area"
                  :rules="$rules.required('必须填写违章区域')"
                ></select-violation-area>
              </v-flex>
              <v-flex key="rule" xs12 v-if="!isTrafficAdmin">
                <select-violation-rule
                  :rules="$rules.required('必须选择违章类型')"
                  v-model="event.results[role].type"
                ></select-violation-rule>
              </v-flex>
              <!--文字信息描述-->
              <v-flex xs12>
                <v-textarea
                  auto-grow
                  label="文字信息描述"
                  prepend-icon="$vuetify.icons.comment"
                  rows="1"
                  v-model="event.results[role].comment"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
          <person-info-card
            flat
            placeholder="车主姓名"
            v-if="hasVehicleInfo"
            :person="event.vehicle.owner"
            subheader="车主信息"
            class="mb-4"
          ></person-info-card>
          <v-subheader>违章取证</v-subheader>
          <v-layout wrap>
            <v-flex xs12>
              <l-image v-if="event.results[role].imageList.length === 0"></l-image>
              <l-image-dialog
                :src="img.src"
                v-for="(img,i) in event.results[role].imageList" :key="i">
                <l-image
                  slot="activator"
                  :src="img.src"
                  :loading="img.loading"
                  :error="img.error"
                  :errorMessage="img.errorMessage"
                >
                  <template slot="action">
                    <v-tooltip bottom>
                      <span>删除图像</span>
                      <v-btn slot="activator" @click="deleteImage(event.results[role].imageList, i)" icon>
                        <v-icon>$vuetify.icons.delete</v-icon>
                      </v-btn>
                    </v-tooltip>
                  </template>
                </l-image>
              </l-image-dialog>
            </v-flex>
            <v-flex xs12>
              <span class="pl-2 error--text caption" v-if="imgError">必须上传至少两张图片 (车牌取证，违章取证)。</span>
            </v-flex>
            <v-flex xs12>
              <l-select-file
                @input="addFile(arguments[0], event.results[role].imageList)"
                file-type="image/*"
                title="添加图片"
              >
                <v-btn color="primary" flat slot="activator">上传图片</v-btn>
              </l-select-file>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-layout class="mt-2 mb-5">
      <v-flex class="text-xs-right">
        <v-btn :loading="submitLoading" class="mx-0" @click="submitEvent" color="primary">提交</v-btn>
      </v-flex>
    </v-layout>
  </l-layout>
</template>

<script>
import LPlatePicker from '../../../components/LPlatePicker'
import {mapState} from 'vuex'
import SelectViolationRule from '../../../components/selectViolationRule'
import {ViolationEvent, Image, VIOLATION_ROLE_TEXT, VIOLATION_ROLE} from '../../../object'
import PersonInfoCard from '../../../components/personInfoCard'
import SelectViolationArea from '../../../components/selectViolationArea'
import imageMixin from './imageMixin'

const MIN_PIC_AMOUNT = 2
export default {
  name: 'ViolationEventSubmit',
  components: {SelectViolationArea, PersonInfoCard, SelectViolationRule, LPlatePicker},
  mixins: [imageMixin],
  data: () => ({
    valid: false,
    event: null,
    role: '',
    hasSearched: false,
    submitLoading: false,
    VIOLATION_ROLE_TEXT
  }),
  computed: {
    ...mapState('violation', [
      'areaList',
      'ruleList'
    ]),
    hasVehicleInfo () {
      let owner = this.event.vehicle.owner || {}
      return owner.name || owner.phone
    },
    imgError () {
      return this.event.results[this.role].imageList.length < MIN_PIC_AMOUNT
    },
    isAlarmAdmin () {
      return this.$route.query.role === VIOLATION_ROLE.ALARM_ADMIN
    },
    isTrafficAdmin () {
      return this.$route.query.role === VIOLATION_ROLE.TRAFFIC_ADMIN
    },
    isViolationAdmin () {
      return this.$route.query.role === VIOLATION_ROLE.VIOLATION_ADMIN
    }

  },
  watch: {
    'event.plate' (v) {
      if (this.$reg.PLATE_PATTERN.test(v)) {
        this.searchVehicle(v)
      }
      else {
        this.hasSearched = false
      }
    }
  },
  methods: {
    async searchVehicle (v) {
      try {
        let {items, amount} = await this.$store.dispatch('pass/searchVehicles', {plate: v})
        // console.log(items, amount)
        if (amount) {
          this.event.vehicle = items[0]
        }
      }
      catch (e) {
        this.$L.error(e.message)
      }
      finally {
        this.hasSearched = true
      }
      console.log(this.hasSearched, this.hasVehicleInfo)
    },
    async submitEvent () {
      let result = this.event.results[this.role]
      let imgs = result.imageList.filter(img => img.isSuccess)
      if (imgs.length < MIN_PIC_AMOUNT) {
        this.$L.alert('error snackbar', '请上传至少两张图片')
        return
      }
      if (this.$refs.event.validate()) {
        console.log('submit', this.event)
        try {
          this.submitLoading = true
          await this.$store.dispatch('violation/submitEvent', this.event)
          this.$L.success('提交成功')
          this.$L.tab.close(this.$L.tab.current, false)
          this.$router.push({
            name: 'ViolationEventManagement',
            params: {refresh: true}
          })
        }
        catch (e) {
          this.$L.error(e.message)
        }
        finally {
          this.submitLoading = false
        }
      }
    },
    deleteImage (target, i) {
      target.splice(i, 1)
    },
    async addFile (file, target) {
      // file 实际上为fileList
      let imageCheckType = ['jpg', 'jpeg', 'png', 'gif']
      let IMAGE_MAX_SIZE = 5 * 1000 * 1000
      for (let f of file) {
        let checkType = imageCheckType
        let maxSize = IMAGE_MAX_SIZE
        // console.log('get file', f)
        let suffix = /\.([^.]*)$/i.exec(f.name)[1]
        if (checkType.indexOf(suffix) === -1) {
          this.$L.error({
            title: '上传文件格式错误',
            message: `上传格式: ${suffix}, 支持的格式: ${checkType.join(',')}`
          })
          return
        }
        else if (f.size > maxSize) {
          this.$L.error({
            title: '文件容量过大',
            message: `文件大小: ${Math.round(f.size / 1000)}KB, 最大限制: ${Math.round(maxSize / 1000)}KB`
          })
          return
        }
      }

      let temp = new Image()
      temp.loading = true
      if (target instanceof Array) {
        target.push(temp)
        // 上传图片
        let img = await this.uploadFile(file)
        this.$set(target, target.length - 1, img)
        this.getImg(img)
      }
    },
    async uploadFile (files) {
      if (files instanceof Object && files.length > 0) {
        let file = files[0]
        let img = new Image()
        try {
          let res = await this.$store.dispatch('uploadFile', {file, url: '/violationApi/violation/file'})
          img.url = res
        }
        catch (e) {
          img.error = true
          img.errorMessage = e.message
        }
        return img
      }
    }
  },
  created () {
    this.event = new ViolationEvent()
    this.role = this.$route.query.role
    this.event.submitBy = this.role
  },
  beforeRouteEnter (to, from, next) {
    if (to.query.role) {
      next()
    }
    else {
      next(false)
    }
  }
}
</script>

<style scoped>

</style>
